import * as React from 'react';
import {renderReact} from 'hypernova-react';
import {I18nContext, I18nManager} from '@shopify/react-i18n';
import {Category} from './Category';

const manager = new I18nManager({locale: 'en-CA'});

export function CategorySection(props) {
  return (
    <I18nContext.Provider value={manager}>
      <Category {...props} />
    </I18nContext.Provider>
  );
}

export default renderReact('Category', CategorySection);
